module.exports = __webpack_public_path__ + "static/img/block05.3bb5ab94.png";